<template>
  <div>
    <el-card shadow="always">
      <el-page-header title="Home" @back="$router.push('/home').catch(() => { })"
        :content="$t('log-sistema')"></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top">
        <el-form-item :label="$t('periodo')" prop="range" :required="true">
          <el-date-picker v-model="ruleForm.range" type="daterange" align="right" unlink-panels range-separator="à"
            format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('tipo')" prop="type">
          <el-select v-model="ruleForm.type">
            <el-option value :label="$t('todos')">{{ $t("todos") }}</el-option>
            <el-option v-for="(name, value) in listType" :key="value" :value="value" :label="name">{{ name }}</el-option>
          </el-select>
        </el-form-item>
        <!--el-form-item :label="$t('usuario')" prop="user">
          <el-select v-model="ruleForm.user">
            <el-option value :label="$t('todos')">{{ $t("todos") }}</el-option>
          </el-select>
        </!--el-form-item-->
        <el-form-item :label="$t('observacao')" prop="observation">
          <el-input ref="name" v-model="ruleForm.observation"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" autofocus @click="fetchRecords">{{
            $t("pesquisar")
          }}</el-button>
        </el-form-item>
      </el-form>
      <br />
      <el-table :data="tableData" stripe style="width: 100%" :default-sort="{ prop: 'name', order: 'ascending' }">
        <el-table-column sortable prop="createdAt" :label="$t('data')">
          <template slot-scope="scope">
            {{ scope.row.createdAt | formatDate }}
          </template>
        </el-table-column>
        <el-table-column sortable prop="user" :label="$t('usuario')">
          <template slot-scope="scope">
            {{ scope.row.user.name }}
          </template>
        </el-table-column>
        <el-table-column prop="ip" :label="$t('ip')"></el-table-column>
        <el-table-column prop="type" :label="$t('tipo')"></el-table-column>
        <el-table-column prop="observation" :label="$t('observacao')"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import { SystemLogService } from "@/services/customers/system.log.services";

import { i18n } from "@/plugin/i18n";
import LogSystemTypeEnum from "@/xpost/enums/LogSystemTypeEnum";

export default {
  name: "SystemLog",
  enums: {
    LogSystemTypeEnum,
  },
  computed: {
    listType() {
      return LogSystemTypeEnum;
    },
  },
  data() {
    return {
      ruleForm: {
        range: [new Date(), new Date()],
        observation: "",
        type: "",
        user: "",
      },
      user: { type: "1" },
      tableData: [],
    };
  },
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const data = {
        startedAt: vm.ruleForm.range[0],
        finishedAt: vm.ruleForm.range[1],
        user: vm.ruleForm.user,
        type: vm.ruleForm.type,
        observation: vm.ruleForm.observation,
      };
      SystemLogService.filter(data)
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
      })
      .catch(() => {
        vm.$message({
          type: "error",
          message: "Usuário sem acesso a essa função",
        });
      });
  },
};
</script>
<style>
.right {
  float: right;
}

.label {
  font-weight: bold;
}
</style>